<template>
  <v-app>
    <div class="page-root">
      <!-- header -->
      <AppHeader />
      <!--body-->
      <v-container class="wrapper pa-0">
        <v-card class="card ma-0 pa-0">
          <v-row class="ma-0 pa-0 align-center" style="height: 100%;">
            <v-col cols="12" sm="6" class="px-8 py-0">
              <LoginForm
                v-if="!signUpStep && !businessSelector"
                :signUpSection="signUpStep"
                @switchMode="signUpStep = $event"
                @business-selector="handleBusinessSelector"
              />
              <RegisterForm
                v-if="signUpStep && !businessSelector"
                :signUpSection="signUpStep"
                @switchMode="signUpStep = $event"
                @business-selector="handleBusinessSelector"
              />
              <BusinessSelector
                v-if="businessSelector"
                :userData="userBusinessData"
                :authToken="token"
                @exit="businessSelector = false"
              />
            </v-col>
            <v-col cols="12" sm="6" class="pa-3 d-none d-sm-flex">
              <img src="@/assets/login/loginImage.png" class="img-login"/>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <!-- footer -->
      <AppFooter />
    </div>
  </v-app>
</template>

<script>
import LoginForm from '@/views/dashboard/pages/login-register/partial/LoginForm.vue'
import RegisterForm from '@/views/dashboard/pages/login-register/partial/RegisterForm.vue'
import BusinessSelector from '@/views/dashboard/pages/login-register/partial/BusinessSelector.vue'
import AppHeader from '@/views/dashboard/pages/login-register/partial/AppHeader.vue'
import AppFooter from '@/views/dashboard/pages/login-register/partial/Footer.vue'

export default {
  name: 'Login',
  components: {
    LoginForm,
    RegisterForm,
    BusinessSelector,
    AppHeader,
    AppFooter
  },
  data: () => ({
    signUpStep: false,
    businessSelector: false,
    userBusinessData: []
  }),
  mounted () {
    if (this.$route.query) {
      localStorage.setItem('additional_data', JSON.stringify(this.$route.query))
    }
  },
  methods: {
    handleBusinessSelector (value) {
      this.businessSelector = value.hasAccount
      this.userBusinessData = value.userData
      this.token = value.Authorization
    }
  }
}
</script>

<style scoped>
.page-root {
  height: 100vh;
  position: relative;
}
.page-root .wrapper {
  top: 61px;
  position: absolute;
  bottom: 28.25px;
}
.page-root .card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-width: 780px;
  height: 531px;
  display: flex;
  align-items: center;
}
.page-root .card .img-login {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 4px;
  background-size: cover;
}
::v-deep .page-root .card::-webkit-scrollbar {
  display: none;
}
@media (max-width: 580px) {
  .page-root .wrapper {
    top: 53px;
    bottom: 28.25px;
  }
}
</style>
